<template>
  <NursingHeader />
  <NursingBody />
</template>
  
<script>
  import NursingHeader from '../molecules/NursingHeader.vue'
  import NursingBody from '../molecules/NursingBody.vue'
  
  export default {
    name: 'NursingView',
    components: {
      NursingHeader,
      NursingBody
    }
  }
</script>
  